export default __webpack_public_path__ + "static/media/gallery_05.b5f46aeb.jpg";